<template>
  <div
    class="attachments-card"
    @dragenter="isDragging = true"
    @dragleave="isDragging = false"
    @dragover.prevent="isDragging = true"
    @drop.prevent="dragDropHandler"
    :class="{dragging: isDragging}"
  >
    <app-card
      class="active"
      :show-header="false"
      :show-footer="false"
    >
      <template #text>
        <div class="attachments-card__top">
          <span class="">
            {{$t('Drop a file here or choose one of these')}}
          </span>
          <app-icon-with-action @click="closeAttachments">
            <i class="fal fa-times-circle cursor-pointer" />
          </app-icon-with-action>
        </div>
        <div class="attachment-option" @click="openAttachmentsLinkForm">
          <i class="fal fa-fw fa-link mar-r-2"/>
          <span class="font-weight-normal">{{$t('Website Link')}}</span>
        </div>
        <div class="attachment-option" @click="attachFile">
          <i class="fal fa-fw fa-paperclip mar-r-2" />
          <span>{{$t('File Attachment')}}</span>
        </div>
        <!-- v-on="$listeners" https://stackoverflow.com/a/56172089/1575353  -->
        <attachment-option-google-picker v-if="shouldShowGooglePicker" class="attachment-option" v-on="$listeners" />
        <attachment-option-one-drive-picker v-if="shouldShowOneDrivePicker" class="attachment-option" v-on="$listeners" />
      </template>
    </app-card>
    <input
      ref="fileInput"
      class="d-none"
      type="file"
      multiple
      @change="uploadFile"
    >
  </div>
</template>

<script>
import { validateFiles } from '@/validations/fileValidations'
import AppCard from '@/components/htmlHelpers/AppCard'
import AppIconWithAction from '@/components/htmlHelpers/AppIconWithAction'
import BaseComponent from '@/components/commentsNew/BaseComponent'
import AttachmentOptionGooglePicker from '@/components/attachmentsNew/AttachmentOptionGooglePicker'
import AttachmentOptionOneDrivePicker from '@/components/attachmentsNew/AttachmentOptionOneDrivePicker'
import { mapState } from 'vuex'

export default {
  name: 'AttachmentsLoaderCard',
  extends: BaseComponent,
  components: { AppIconWithAction, AppCard, AttachmentOptionGooglePicker, AttachmentOptionOneDrivePicker },
  props: {
    itemData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    ...mapState('InfoStore', ['info']),
    shouldShowGooglePicker () {
      return this.info.shouldShowGooglePicker || window.shouldShowGooglePicker
    },
    shouldShowOneDrivePicker () {
      return this.info.shouldShowOneDrivePicker || window.shouldShowOneDrivePicker
    }
  },
  data () {
    return {
      isDragging: false
    }
  },
  methods: {
    openAttachmentsLinkForm () {
      this.$emit('open-link-form')
    },
    closeAttachments () {
      this.$emit('close')
    },
    attachFile () {
      this.$refs.fileInput.click()
    },
    dragDropHandler (event) {
      if (!(event.dataTransfer && event.dataTransfer.types && event.dataTransfer.types.indexOf('Files') > -1)) {
        return
      }
      if (event.type === 'drop') {
        this.$refs.fileInput.files = event.dataTransfer.files
        this.uploadFile()
      }
      event.dataTransfer.dropEffect = 'copy'
    },
    uploadFile () {
      const fileValidationsResult = validateFiles(this.$refs.fileInput.files)
      const { validFiles, error, errorMessage, invalidFiles } = fileValidationsResult
      if (error) {
        console.error(errorMessage)
      }
      if (invalidFiles) {
        for (const file of invalidFiles) {
          console.error(file)
        }
      }
      if (!validFiles.length) {
        return
      }
      this.uploading = true
      const formData = new FormData()
      for (const file of validFiles) {
        formData.append('files[]', file)
      }
      for (const [key, value] of Object.entries(this.itemData)) {
        formData.set(key, value)
      }
      this.$emit('file-loaded', formData)
    }
  }
}
</script>

<style scoped lang="scss">
@import "src/assets/scss/variables";
.attachments-card {

  .card-body {
    padding: 0
  }

  &__top {
    color: $gray-600;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid $gray;
    padding: .5rem .625rem;
    margin: -.75rem -.75rem .5rem;
  }

  &.dragged-over {
    .app-card.card {
      background-color: lightgrey;
    }
  }

  &.dragging {
    .app-card.card {
      background-color: #0A5AB429;
      opacity: .7;
    }
  }
}

.attachment-option {
  display: flex;
  align-items: center;
  text-align: start;
  cursor: pointer;
  font-size: 1rem;
  border-radius: 4px;
  padding: .625rem;
  color: $text-color-gray;

  &:hover {
    color: $white;
    background-color: $primary;
  }

  iframe {
    border: 0;
  }
}
</style>
